import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import ListUi from "./ListUi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  AllZipOscillaAudiogramApi,
  getBeneficiaryApi,
  getDashboardApi,
} from "../../apis/beneficiary.api";
import { callApiAction } from "../../store/actions/commonAction";
import CreateController from "./CreateController";
import { Download, Edit, KeyboardArrowRight, Visibility } from "@mui/icons-material";
import { downloadAudiogramApi } from "../../apis/oscilla.api";
import fileDownload from "js-file-download";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";
import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import { openModal } from "../../store/actions/modalAction";
import DetailedViewController from "../beneficiary/detailedview/DetailedViewController";
import { findObjectKeyByValue } from "../../utils/helper";
import { LEVEL_OF_HEARING_LOSS } from "../../utils/beneficiary.constant";

const BeneficiaryActionComponent = memo(
  ({ params, setParams, modalKey, filters }) => {
    const dispatch = useDispatch();
    const anchorRef = useRef(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [open, setOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const handleToggle = () => {
      setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }

      setOpen(false);
    };
    const onViewMore = () => {
      dispatch(
        openModal(
          <DetailedViewController id={params._id} />,
          "md",
          false,
          "beneficiary-detailed-view",
        ),
      );
    };

    useEffect(() => {
      if (modalOpen) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    }, [modalOpen]);
    const navigate = useNavigate();
    const onViewMores = () => {
      navigate(`/beneficiary/${params._id}`, {
        state: { patientData: params },
      });
    };

    const [downloadLoading, setDownloadLoading] = useState(false);

    const onDownloadClick = (params) => {
      setDownloadLoading(true);
      dispatch(
        callApiAction(
          async () => {
            const response = await downloadAudiogramApi({ id: params?._id });
            return response;
          },
          (response) => {
            let pdfBlob =
              response instanceof Blob
                ? response
                : new Blob([response], { type: "application/pdf" });
            const reader = new FileReader();
            reader.onloadend = () => { };
            reader.readAsText(pdfBlob);
            fileDownload(
              pdfBlob,
              `${params?.first_name} ${params?.last_name}'s audiogram.pdf`,
            );
            setDownloadLoading(false);
          },
          (err) => {
            dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error));
            setDownloadLoading(false);
          },
          true,
        ),
      );
    };

    return (
      <Box sx={{ width: "100%", display: "flex" }}>
        <IconButton
          fullWidth
          color="info"
          disableElevation
          size="inherit"
          onClick={onViewMore}
        >
          <Visibility />
        </IconButton>
        <IconButton size="inherit" onClick={onViewMores}>
          <Edit color="info" fontSize="inherit" />
        </IconButton>
        <IconButton
          onClick={async (e) => await onDownloadClick(params)}
          sx={{ padding: 0, ml: 2 }}
        >
          <Tooltip title="Download Audiogram">
            {!downloadLoading ? (
              <Download sx={{ color: "#2D3B67" }} />
            ) : (
              <CircularProgress color="primary" size="25px" />
            )}
          </Tooltip>
        </IconButton>

      </Box>
    );
  },
);

const ListController = ({ defaultFilters = {} }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const title = "Beneficiary Data ";
  const modalKey = "beneficiary";
  const fetchApi = getBeneficiaryApi;

  const columns = useMemo(
    () => [
      {
        id: 1,
        fieldName: "createdAt",
        label: "Created Date",
        align: "left",
        sort: true,
        renderValue: (fields) =>
          fields.createdAt
            ? moment(fields.createdAt).format("DD/MM/YYYY")
            : "NA",
      },
      {
        id: 2,
        fieldName: "first_name",
        label: "Name",
        align: "left",
        sort: true,
        renderValue: (params) =>
          params.first_name +
          " " +
          `${params.last_name ? params.last_name : ""}`,
      },
      {
        id: 3,
        fieldName: "left_ear_level_of_loss",
        label: "Left Ear",
        align: "left",
        sort: true,
        renderValue: (params) =>
          findObjectKeyByValue(
            params.left_ear_level_of_loss,
            LEVEL_OF_HEARING_LOSS,
          ) || "NA",
      },
      {
        id: 4,
        fieldName: "right_ear_level_of_loss",
        label: "Right Ear",
        align: "left",
        sort: true,
        renderValue: (params) =>
          findObjectKeyByValue(
            params.right_ear_level_of_loss,
            LEVEL_OF_HEARING_LOSS,
          ) || "NA",
      },
      {
        id: 5,
        fieldName: "created_by",
        label: "Tested By",
        align: "left",
        sort: true,
        renderValue: (params) =>
          params.created_by ? params.created_by.name : "NA",
      },
      {
        id: 7,
        fieldName: "action",
        label: "Action",
        align: "left",
        renderValue: (params, setParams) => (
          <BeneficiaryActionComponent params={params} setParams={setParams} />
        ),
      },
    ],
    [dispatch],
  );

  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ["first_name", "last_name", "phone"],
    sort: "createdAt",
    donation_event_id: null,
    camp: null,
    camp_name: "",
    country: null,
    state: null,
    district: null,
    // status: null,
    taluka: null,

    udise_file: "",
    photo: "",
    aadhar_file: "",
    income_certi: "",
    sortDirection: -1,
    hearingLoss: 8,
    user: "",
    user_name:"",
    ...defaultFilters,
  });

  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [exportLoading, setexportLoading] = useState(false);
  const [exportzipLoading, setexportzipLoading] = useState(false);
  const [list, setList] = useState({});

  const fetchList = (isExport) => {
    if (!isExport) {
      setLoading(true);
      dispatch(
        callApiAction(
          async () => await fetchApi({ ...filters }),
          (response) => {
            setList(response);
            setLoading(false);
          },
          (err) => {
            setLoading(false);
          },
        ),
      );
    } else {
      setexportLoading(true);
      dispatch(
        callApiAction(
          async () => await fetchApi({ ...filters, csv: true }),
          (response) => {
            fileDownload(response, "beneficiary.csv");
            setexportLoading(false);
          },
          (err) => {
            console.log(err);
            setexportLoading(false);
          },
          true,
        ),
      );
    }
  };

  const callBackFun = useCallback(
    ({ _id, name, surname }) => {
      fetchList();
    },
    [filters],
  );

  const onCreateBtnClick = () => {
    dispatch(
      openModal(
        <CreateController
          callBack={async () => {
            fetchList();
          }}
        />,
        "sm",
        false,
        modalKey,
      ),
    );
    // navigate("/add/")
  };

  const onExportBtnClick = () => {
    fetchList(true);
  };

  useEffect(() => {
    fetchList();
  }, [filters]);

  const handleDownload = async () => {
    setexportzipLoading(true);
    const success = await AllZipOscillaAudiogramApi({
      id: filters?.camp,
      name: filters?.camp_name,
    });
    if (success) {
      setexportzipLoading(false);
    } else {
      setexportzipLoading(false);
    }
  };

  const [data, setData] = useState(null);
  const fetchCountFun = () => {
    setLoading1(true);
    dispatch(
      callApiAction(
        async () => await getDashboardApi({ ...filters }),
        (response) => {
          setData([response.hearingLossCounts]);
          setLoading1(false);
        },
        () => setLoading1(false),
      ),
    );
  };
  useEffect(() => {
    fetchCountFun();
  }, [
    filters.camp,
    filters.user,
    filters.camp_name,
    filters.country,
    filters.state,
    filters.district,
    filters.taluka,
  ]);
  console.log("data", data);
  return (
    <>
      <ListUi
        callBackFun={callBackFun}
        title={title}
        onCreateBtnClick={onCreateBtnClick}
        exportLoading={exportLoading}
        onExportBtnClick={onExportBtnClick}
        filters={filters}
        setFilters={setFilters}
        loading={loading}
        list={list}
        columns={columns}
        handleDownload={handleDownload}
        exportzipLoading={exportzipLoading}
        data={data}
        loading1={loading1}
      />
    </>
  );
};
export default ListController;
